import Modal from 'react-modal';

const ModalComponents = ({ open, onRequestClose, children, clickOverlay }) => {
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'transparent',
      border: 'none',
    },
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={onRequestClose}
      style={customStyles}
      shouldCloseOnOverlayClick={clickOverlay ? clickOverlay : true}>
      {children}
    </Modal>
  );
};

export default ModalComponents;
